import React from 'react';
import { Link } from 'react-router-dom';
import { FaBroom, FaWindowMaximize, FaWater, FaRoad, FaSolarPanel, FaSwimmingPool, FaCouch, FaTree, FaBrush, FaBuilding, FaSprayCan, FaBorderAll, FaIndustry } from 'react-icons/fa';

const SERVICE_ICONS = {
  'Pressure Washing': <FaWater className="text-3xl text-[#b87c4c]" />,
  'Window Cleaning': <FaWindowMaximize className="text-3xl text-[#b87c4c]" />,
  'Gutter Cleaning': <FaBroom className="text-3xl text-[#b87c4c]" />,
  'Driveway Cleaning': <FaRoad className="text-3xl text-[#b87c4c]" />,
  'Sidewalk Cleaning': <FaBorderAll className="text-3xl text-[#b87c4c]" />,
  'Patio Cleaning': <FaCouch className="text-3xl text-[#b87c4c]" />,
  'Deck Cleaning': <FaTree className="text-3xl text-[#b87c4c]" />,
  'Fence Cleaning': <FaBrush className="text-3xl text-[#b87c4c]" />,
  'Solar Panel Cleaning': <FaSolarPanel className="text-3xl text-[#b87c4c]" />,
  'Pool Deck Cleaning': <FaSwimmingPool className="text-3xl text-[#b87c4c]" />,
  'Commercial Concrete Cleaning': <FaIndustry className="text-3xl text-[#b87c4c]" />,
  'Graffiti Removal': <FaSprayCan className="text-3xl text-[#b87c4c]" />,
  'Concrete Cleaning': <FaIndustry className="text-3xl text-[#b87c4c]" />,
};

const SERVICE_LINKS = {
  'Pressure Washing': '/pressure-washing',
  'Window Cleaning': '/window-cleaning',
  'Gutter Cleaning': '/gutter-cleaning',
  'Driveway Cleaning': '/driveway-cleaning',
  'Sidewalk Cleaning': '/sidewalk-cleaning',
  'Patio Cleaning': '/patio-cleaning',
  'Deck Cleaning': '/deck-cleaning',
  'Fence Cleaning': '/fence-cleaning',
  'Solar Panel Cleaning': '/solar-panel-cleaning',
  'Pool Deck Cleaning': '/pool-deck-cleaning',
  'Commercial Concrete Cleaning': '/commercial-concrete-cleaning',
  'Graffiti Removal': '/graffiti-removal',
  'Concrete Cleaning': '/commercial-concrete-cleaning',
};

function ServiceGrid({ services }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {services.map((service) => (
        <Link
          to={SERVICE_LINKS[service] || '/'}
          key={service}
          className="group block p-6 bg-white rounded-xl shadow hover:shadow-lg transition-shadow duration-200 border border-gray-100 hover:border-[#b87c4c] text-center"
        >
          <div className="flex justify-center mb-4">{SERVICE_ICONS[service]}</div>
          <h3 className="text-xl font-semibold text-[#4a3f35] mb-2 group-hover:text-[#b87c4c] transition-colors duration-200">{service}</h3>
          <p className="text-gray-600 text-sm">Professional {service.toLowerCase()} for your home or business.</p>
        </Link>
      ))}
    </div>
  );
}

export default ServiceGrid; 